<template>
    <div ref="macroaxis" :id="container"></div>
</template>
 
<script>
const SCRIPT_ID = "macroaxis-stock-ticker-widget";
const CONTAINER_ID = "my_xss_magic";
export default {
  name: "StockTicker",
  data() {
    return {
      container: CONTAINER_ID,
    };
  },
  methods: {
    canUseDOM() {
      return (
        typeof window !== "undefined" &&
        window.document &&
        window.document.createElement
      );
    },
    getScriptElement() {
      return document.getElementById(SCRIPT_ID);
    },
    updateOnloadListener(onload) {
      const script = this.getScriptElement();
      const oldOnload = script.onload;
      return (script.onload = () => {
        oldOnload();
        onload();
      });
    },
    scriptExists() {
      return this.getScriptElement() !== null;
    },
    appendScript(onload) {
      if (!this.canUseDOM()) {
        onload();
        return;
      }

      if (this.scriptExists()) {
        if (typeof TradingView === "undefined") {
          this.updateOnloadListener(onload);
          return;
        }
        onload();
        return;
      }
      const script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.type = 'text/javascript';
      script.src = "https://www.macroaxis.com/widgets/url.jsp?t=42";
      script.onload = onload;

      this.$refs.macroaxis.appendChild(script);
    },
    initWidget() {
       
    },
  },
  mounted() {
    setTimeout(() => {
      this.appendScript(this.initWidget)
    }, 300)
  }
};
</script>
